/* eslint-disable react/jsx-no-comment-textnodes */
import Checkout_header from "./header";
import OrderDescription from "./order-description";
import OrderDelivery from "./order-delivery";
import OrderPaymentMethod from "./order-payment-method";
import OrderPaymentGateway from "./order-payment-gateway";
import TotalCart from "../component-cart/total-cart";

import {
  useShipping,
  useShippingOptions,
  usePayment,
} from "../../hooks/apis/shipping";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCartStore } from "../../store/useCartStore";

function Checkout_content() {
  const { shopping, loading } = useCartStore((state) => state);

  const navigate = useNavigate();
  const [body, setBody] = useState({});

  const { data, isLoading } = useShippingOptions();
  const { data: shippingData, mutate, isError, isSuccess } = useShipping();
  const {
    data: shippingPaymentData,
    refetch: shippingPaymentRefetch,
    isError: shippingPaymentError,
    isSuccess: shippingPaymentSuccess,
  } = usePayment(isSuccess);

  const handleChangeData = (newData) => {
    setBody((prevState) => ({ ...prevState, ...newData }));
  };

  const handleSubmit = () => {
    mutate(body);
  };

  useEffect(() => {
    if (isSuccess) {
      shippingPaymentRefetch();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (shippingPaymentSuccess) {
      window.location.href = shippingPaymentData.payment_link.action;
    }
  }, [shippingPaymentSuccess, isSuccess]);

  if (isLoading)
    return (
      <div className="active loading">
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
    );

  // if (error) alert(JSON.stringify(error.response?.data?.msg));

  return (
    <div id="checkout">
      <Checkout_header />
      {shopping.total_items !== 0 ? (
        <>
          {" "}
          <div className="container">
            <div className="row">
              <div className="col-lg-9 m-auto col-12">
                <form>
                  <OrderDescription handleChangeData={handleChangeData} />
                  <OrderDelivery
                    options={data?.delivery_types}
                    handleChangeData={handleChangeData}
                  />
                  <OrderPaymentMethod
                    options={data?.payment_methods}
                    handleChangeData={handleChangeData}
                  />
                  <OrderPaymentGateway
                    options={data?.payment_gateways}
                    handleChangeData={handleChangeData}
                  />
                  <TotalCart />
                </form>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-9 col-12 m-auto">
                <button className="checkout" onClick={handleSubmit}>
                  پرداخت
                </button>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default Checkout_content;
